import React from 'react'

import { Footer } from '@frame/ui-components/footer'
import { WidgetHeaderWithNavigation } from '@frame/ui-components/widget-header'
import { Body } from '@frame/ui-primitives/body'
import { Button } from '@frame/ui-primitives/button'
import { H2 } from '@frame/ui-primitives/h2'

import { useDocumentsFlowContext } from '@documents/contexts/documents-flow-context'
import { useFileUploadContext } from '@documents/contexts/file-upload-context'
import { useAutoNavigate } from '@frame/lib/hooks/useAutoNavigate'
import { useHeaderTitle } from '@frame/lib/hooks/useHeaderTitle'
import { useShowExitPrompt } from '@frame/lib/hooks/useShowExitPrompt'
import { DataAttribute } from '@frame/types'

import { AlternativeMethodsCards } from '../components/alternative-methods-cards'

export function AlternativeMethods() {
  const { setTrackedFiles } = useFileUploadContext()
  const { setSelectedDocumentType, setSelectedOtherDocumentTypes } = useDocumentsFlowContext()

  const { mutateAndNavigate } = useAutoNavigate()
  const title = useHeaderTitle()
  const showExitPrompt = useShowExitPrompt()

  function handleStartOver() {
    // Clear out tracked file state when starting over
    setTrackedFiles([])

    // Clear out the document type option selected (paystub/w2, other, none)
    setSelectedDocumentType(null)

    // Clear out any other document types selected
    setSelectedOtherDocumentTypes([])

    // Mutate and navigate to the next screen
    mutateAndNavigate()
  }

  return (
    <>
      <WidgetHeaderWithNavigation title={title} showExitPrompt={showExitPrompt} />
      <Body data-cy={DataAttribute.DOCUMENTS_SCREEN_ALTERNATIVE_METHODS} className="p-5" paddingTopOverride={0}>
        <H2 className="text-left">Alternative methods</H2>
        <div className="mt-4 flex flex-col gap-4">
          <AlternativeMethodsCards />
        </div>
      </Body>
      <Footer
        buttons={{
          primary: (
            <Button disabled={false} intent="tertiary" onClick={handleStartOver}>
              Start over
            </Button>
          ),
        }}
      />
    </>
  )
}
